import React, { useEffect, useRef, useState } from "react";
import icons from "../../assets/images/sprite-other-icons.svg";
import { useDispatch, useSelector } from "react-redux";
import { getFromLocalStorage, buildGameLaunchUrl } from "../../services/helper/cl_Helper";
import { useNavigate } from "react-router";
import { getAllGames, setGamePopup } from "../crashGames/cl_CrashSlice";
import BackArrow from "./BackArrow";
import PaginationComponent from "./PaginationComponent";
import statickImg from "../../assets/images/popup/staticImg.webp";
import { setCrashGames } from "../signIn/cl_SignInSlice";
import HomeModal from "../home/HomeModal";
import { useParams, useLocation } from "react-router-dom";

const ViewAll = () => {
  const { gameType } = useParams();

  const dispatch = useDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const [filteredGames, setFilteredGames] = useState([]);
  const [selectedProvider, setSelectedProvider] = useState("all");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [sortOrder, setSortOrder] = useState("popular");
  const { gamePopup, getAllgamesList } = useSelector((state) => state?.crash);
  let location = useLocation();

  // Only fetch here if the list isn't already loaded (e.g. a direct load or
  // reload of this page, where Redux is empty). If the user navigated here
  // from Home, that mount's fetch already populated getAllgamesList, so
  // fetching again here would just duplicate the same request.
  useEffect(() => {
    if (!getAllgamesList?.length) {
      dispatch(getAllGames());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const liveCategoryGames = getAllgamesList?.find(
    (category) => category.game_type === gameType
  )?.game;

  // The URL param `gameType` is the source of truth for the current category.
  // `location.state` is transient history state that can linger from a
  // previous navigation (e.g. a "Slots" click), so only trust it when it
  // actually belongs to the route we're on. Every fresh navigation sets
  // `state.game_type` equal to the URL param; stale state won't match.
  const isStateForCurrentRoute = location?.state?.game_type === gameType;

  const allLiveCasino =
    liveCategoryGames ||
    (isStateForCurrentRoute ? location?.state?.gamesList : null) ||
    [];
  const gameTitle =
    (isStateForCurrentRoute && location?.state?.title) || gameType;
  const { searchInput } = useSelector((state) => state?.crash);
  const { homePopUp } = useSelector((state) => state?.signIn);

  const topRef = useRef(null);
  useEffect(() => {
    topRef.current.scrollIntoView(true);
  }, []);

  useEffect(() => {
    if (gameTitle === "Crash Games") {
      dispatch(setCrashGames(true));
    } else {
      dispatch(setCrashGames(false));
    }
  }, [gameTitle]);

  useEffect(() => {
    filterGames();
  }, [
    selectedProvider,
    selectedCategory,
    sortOrder,
    allLiveCasino,
    searchInput,
  ]);

  const filterGames = () => {
    let filtered = [...allLiveCasino];

    if (searchInput) {
      filtered = filtered.filter((game) =>
        game.name.toLowerCase().includes(searchInput.toLowerCase())
      );
    }

    if (selectedCategory !== "all") {
      filtered = filtered.filter(
        (game) =>
          game.categoryname?.toLowerCase() === selectedCategory.toLowerCase()
      );
    }

    if (selectedProvider !== "all") {
      filtered = filtered.filter(
        (game) => game.provider.toLowerCase() === selectedProvider.toLowerCase()
      );
    }

    setFilteredGames(filtered);
    setCurrentPage(1);
  };

  const navigate = useNavigate();

  const navigateToGamePopup = (game) => {
    const token = getFromLocalStorage("gk");
    if (token) {
      const url = buildGameLaunchUrl(game, { gameClose: true });
      window.location.href = url;
      dispatch(setGamePopup(false));
      // dispatch(setHomePopUp(false));
    } else {
      navigate("/signin");
      // dispatch(setHomePopUp(false));
    }
  };

  const itemsPerPage = 24;
  const gamesData = filteredGames;
  const totalPages = Math.ceil(gamesData?.length / itemsPerPage);

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, gamesData?.length);
  const displayedGames = gamesData?.slice(startIndex, endIndex);

  const providers = [...new Set(allLiveCasino?.map((game) => game.provider))];
  const providerCounts = providers.reduce((acc, provider) => {
    acc[provider] = allLiveCasino.filter(
      (game) => game.provider === provider
    ).length;
    return acc;
  }, {});

  const categories = [
    ...new Set(
      allLiveCasino
        ?.map((game) => ({
          name: game.categoryname,
          order: game.order,
        }))
        .filter((cat) => cat.name)
        .sort((a, b) => a.order - b.order)
        .map((cat) => cat.name)
    ),
  ];
  const groupedGames = displayedGames.reduce((acc, game) => {
    const category = game.categoryname || "--";
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(game);
    return acc;
  }, {});
  const goBack = () => {
    navigate("/");
  };
  return (
    <>
      {gamePopup && <HomeModal />}
      <div className="SB-page-content SB-livecasinoGames-page" ref={topRef}>
        <div
          className={`SB-gameCategory-section ${
            gameTitle === "Crash Games"
              ? "SB-crashGames"
              : "SB-liveCasino SB-viewAllPage"
          }`}
        >
          <div className="SB-casinoCategoryItem">
            <div className="SB-casinoCategoryItem-header">
              <div className="SB-pageBackButton SB-iconSVG" onClick={goBack}>
                <svg xmlns="http://www.w3.org/2000/svg">
                  <use xlinkHref={`${icons}#${"icon-back"}`} />
                </svg>
              </div>
              <div className="SB-casinoCategoryItem-title">{gameTitle}</div>
            </div>
            <div className="SB-filterDropdowns SB-gamesfilterDropdowns">
              <div className="SB-select">
                <select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                >
                  <option value="all">All Categories</option>
                  {categories.map((category, index) => (
                    <option key={index} value={category}>
                      {category}
                    </option>
                  ))}
                </select>
              </div>
              <div className="SB-select">
                <select
                  value={selectedProvider}
                  onChange={(e) => setSelectedProvider(e.target.value)}
                >
                  <option value="all">Filter by Provider</option>
                  {providers.map((provider, index) => (
                    <option key={index} value={provider}>
                      {provider === "Split The Pot"
                        ? "stp"
                        : provider === "turbogames"
                        ? "Turbo"
                        : provider
                            .replace(/_/g, " ")
                            .replace(/\b\w/g, (l) => l.toUpperCase())}
                      <>
                        ({providerCounts[provider]})
                      </>
                    </option>
                  ))}
                </select>
              </div>{" "}
            </div>
            {displayedGames?.length > 0 ? (
              <div className="SB-tab-content">
                <div className="SB-casinoCategoryGroup">
                  {Object.entries(groupedGames).map(([category, games]) => (
                    <div className="SB-casinoCategoryItem-games" key={category}>
                      <div className="SB-casinoCategoryItem-header">
                        <div className="SB-casinoCategoryItem-title">
                          {category}{" "}
                          <>
                            ({filteredGames?.length || 0})
                          </>
                        </div>
                      </div>
                      <div
                        className={`SB-casinoGamesList ${
                          gameTitle === "Crash Games" && "SB-NE-GamesList"
                        }`}
                      >
                        <ul>
                          {games.map((game, index) => (
                            <li key={index}>
                              <div className="SB-casinoGameItem SB-livecasinoGameItem">
                                <div
                                  className="SB-casinoGameItem-container"
                                  onClick={() => navigateToGamePopup(game)}
                                >
                                  <img
                                    src={
                                      (game?.image?.configurl ||
                                        game?.image?.url) === "NoIcon"
                                        ? statickImg
                                        : game?.image?.configurl ||
                                          game?.image?.url ||
                                          statickImg
                                    }
                                    loading="lazy"
                                    onError={(e) => {
                                      e.target.src = statickImg;
                                    }}
                                  />
                                  <div className="SB-casinoGameItem-playGame-container">
                                    <div className="SB-btnPlayGame">
                                      <div className="SB-iconSVG">
                                        <svg xmlns="http://www.w3.org/2000/svg">
                                          <use
                                            xlinkHref={`${icons}#${"icon-casino-play"}`}
                                          />
                                        </svg>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="SB-casinoGameItem-footer">
                                  <div className="SB-casinoGameTitle">
                                    {game?.name
                                      ? game.name.charAt(0).toUpperCase() +
                                        game.name.slice(1).toLowerCase()
                                      : ""}
                                  </div>
                                  <div className="SB-casinoGameSubTitle">
                                    {game?.provider === "split_the_pot"
                                      ? "stp"
                                      : game?.provider === "turbogames"
                                      ? "turbo"
                                      : game?.provider}
                                  </div>
                                </div>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  ))}
                  {gamesData?.length > 0 && (
                    <PaginationComponent
                      currentPage={currentPage}
                      totalCount={gamesData?.length || 0}
                      pageSize={itemsPerPage}
                      onPageChange={(page) => setCurrentPage(page)}
                      setCurrentPage={setCurrentPage}
                    />
                  )}
                  {homePopUp && <HomeModal />}
                </div>
              </div>
            ) : (
              <div className="SB-msgBox">
                <div className="SB-msgBox-container">
                  Currently there is no games available
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewAll;
